import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["formContainer", "toggleButton", "toggleText", "chevronDown", "chevronUp"]
    static values = {closed: Boolean}

    connect() {
        this.updateUI()
    }

    toggle() {
        this.closedValue = !this.closedValue
        this.updateUI()
    }

    updateUI() {
        if (this.closedValue) {
            this.formContainerTarget.classList.add("hidden")
            this.toggleTextTarget.textContent = "Show Filters"
            this.chevronDownTarget.classList.remove("hidden")
            this.chevronUpTarget.classList.add("hidden")
        } else {
            this.formContainerTarget.classList.remove("hidden")
            this.toggleTextTarget.textContent = "Hide Filters"
            this.chevronDownTarget.classList.add("hidden")
            this.chevronUpTarget.classList.remove("hidden")
        }
    }

    closedValueChanged() {
        this.updateUI()
    }
}
